import api from './api';

// Dashboard
export const amlAPI = {
  // Dashboard
  getDashboardMetrics: () => api.get('/api/aml/dashboard/metrics'),
  getDashboardAlerts: () => api.get('/api/aml/dashboard/alerts'),
  getDashboardActivity: (limit = 20) => api.get(`/api/aml/dashboard/activity?limit=${limit}`),
  
  // Risk Assessments
  listRiskAssessments: (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.client_id) queryParams.append('client_id', params.client_id);
    if (params.risk_level) queryParams.append('risk_level', params.risk_level);
    if (params.status) queryParams.append('status', params.status);
    return api.get(`/api/aml/risk-assessments?${queryParams.toString()}`);
  },
  createRiskAssessment: (data) => api.post('/api/aml/risk-assessments', data),
  getRiskAssessment: (id) => api.get(`/api/aml/risk-assessments/${id}`),
  updateRiskAssessment: (id, data) => api.patch(`/api/aml/risk-assessments/${id}`, data),
  approveRiskAssessment: (id) => api.post(`/api/aml/risk-assessments/${id}/approve`),
  
  // KYC Records
  listKYCRecords: (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.client_id) queryParams.append('client_id', params.client_id);
    if (params.verification_status) queryParams.append('verification_status', params.verification_status);
    if (params.record_type) queryParams.append('record_type', params.record_type);
    return api.get(`/api/aml/kyc-records?${queryParams.toString()}`);
  },
  createKYCRecord: (data) => api.post('/api/aml/kyc-records', data),
  getKYCRecord: (id) => api.get(`/api/aml/kyc-records/${id}`),
  updateKYCRecord: (id, data) => api.patch(`/api/aml/kyc-records/${id}`, data),
  verifyKYCRecord: (id) => api.post(`/api/aml/kyc-records/${id}/verify`),
  
  // Audit Logs
  listAuditLogs: (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.client_id) queryParams.append('client_id', params.client_id);
    if (params.event_type) queryParams.append('event_type', params.event_type);
    if (params.start_date) queryParams.append('start_date', params.start_date);
    if (params.end_date) queryParams.append('end_date', params.end_date);
    if (params.limit) queryParams.append('limit', params.limit);
    return api.get(`/api/aml/audit-logs?${queryParams.toString()}`);
  },
  
  // Reviews
  listReviews: (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.client_id) queryParams.append('client_id', params.client_id);
    if (params.status) queryParams.append('status', params.status);
    return api.get(`/api/aml/reviews?${queryParams.toString()}`);
  },
  createReview: (data) => api.post('/api/aml/reviews', data),
  updateReview: (id, data) => api.patch(`/api/aml/reviews/${id}`, data)
};